export default __webpack_public_path__ + "static/media/misc-pantry2-1024w.2e419802.png";